import { createContext } from 'react';

import DefaultLayout from '../flows/DefaultLayout';
import { type OBLayout } from '../types/OBLayout';

const OBLayoutContext = createContext<OBLayout>(DefaultLayout);

export default OBLayoutContext;
